<template>
  <div class="radio-button-field">
    <vl-form-message-label v-if="label" :for="name">
      {{ label }}
    </vl-form-message-label>
    <Field v-slot="{ handleChange, value, errors }" :name="name">
      <vl-form-message-error v-if="errors">{{ errors[0] }}</vl-form-message-error>
      <template v-for="(item, index) in values" :key="index">
        <vl-radio
          :id="`${name}-${index}`"
          :name="`${name}-${index}`"
          :modelValue="value"
          :value="item.value"
          :mod-error="!!errors.length"
          @input="handleChange"
        >
          {{ item.label }}
        </vl-radio>
      </template>
    </Field>
  </div>
</template>

<script lang="ts" setup>
import { Field } from 'vee-validate';
import { PropType } from 'vue';

export type PbsRadioFieldValue = {
  value: string | number;
  label: string;
};

defineProps({
  name: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: false,
    default: ''
  },
  values: {
    type: Array as PropType<PbsRadioFieldValue[]>,
    required: true,
    default: () => []
  }
});
</script>

<style scoped lang="scss">
.radio-button-field {
  display: inline-block;
}
</style>
